import { TRESPONSE_GET_TNA_ORDER_TEMPLATE } from '@monorepo/types';

export type TTnAOrderTemplateState = {
  tnaOrderTemplateInfo: TRESPONSE_GET_TNA_ORDER_TEMPLATE | null;
  showTnAOrderTemplatesLoader: boolean;
};

export const TTnAOrderTemplateActionType = {
  SetShowTnAOrderTemplatesLoader: 'SET_SHOW_TNA_ORDER_TEMPLATES_LOADER' as const,
  ClearTnAOrderTemplates: 'CLEAR_TNA_ORDER_TEMPLATES_DETAILS' as const,
  GetTnAOrderTemplates: 'GET_TNA_ORDER_TEMPLATES' as const,
  GetTnAOrderTemplatesSuccess: 'GET_TNA_ORDER_TEMPLATES_SUCCESS' as const,
  GetTnAOrderTemplatesFailure: 'GET_TNA_ORDER_TEMPLATES_FAILURE' as const,
  AutoUpdateTargetDates: 'AUTO_UPDATE_TARGET_DATES' as const,
  AutoUpdateTargetDatesSucces: 'AUTO_UPDATE_TARGET_DATES_SUCCESS' as const,
  AutoUpdateTargetDatesFailure: 'AUTO_UPDATE_TARGET_DATES_FAILURE' as const,
  AddUpdateTnAOrderTemplate: 'ADD_UPDATE_TNA_ORDER_TEMPLATE' as const,
  AddUpdateTnAOrderTemplateSuccess: 'ADD_UPDATE_TNA_ORDER_TEMPLATE_SUCCESS' as const,
  AddUpdateTnAOrderTemplateFailure: 'ADD_UPDATE_TNA_ORDER_TEMPLATE_FAILURE' as const,
  DeleteTnAOrderTemplate: 'DELETE_TNA_ORDER_TEMPLATE' as const,
  DeleteTnAOrderTemplateSuccess: 'DELETE_TNA_ORDER_TEMPLATE_SUCCESS' as const,
  DeleteTnAOrderTemplateFailure: 'DELETE_TNA_ORDER_TEMPLATE_FAILURE' as const,
  UpdateStepByTemplateId: 'UPDATE_STEP_BY_TEMPLATE_ID' as const,
  UpdateStepByTemplateIdSuccess: 'UPDATE_STEP_BY_TEMPLATE_ID_SUCCESS' as const,
  UpdateStepByTemplateIdFailure: 'UPDATE_STEP_BY_TEMPLATE_ID_FAILURE' as const,
  DownloadTnaOrderTemplate: 'DOWNLOAD_TNA_ORDER_TEMPLATE' as const,
  DownloadTnaOrderTemplateSuccess: 'DOWNLOAD_TNA_ORDER_TEMPLATE_SUCCESS' as const,
  DownloadTnaOrderTemplateFailure: 'DOWNLOAD_TNA_ORDER_TEMPLATE_FAILURE' as const,
};
